import React from 'react';
import type { MyGigsTab } from './types';
import { TOUR, tourTarget, type TourTargetId } from '../../../onboarding/targets';
import { TakeTourButton } from '../../../onboarding/TakeTourButton';

interface MyGigsHeaderProps {
  activeTab: MyGigsTab;
  onTabChange: (tab: MyGigsTab) => void;
  inquiriesCount?: number;
  applicantsCount?: number;
  offersCount?: number;
}

export const MyGigsHeader: React.FC<MyGigsHeaderProps> = ({
  activeTab,
  onTabChange,
  inquiriesCount = 0,
  applicantsCount = 0,
  offersCount = 0,
}) => {
  const tabs: { id: MyGigsTab; label: string; count?: number; tour: TourTargetId }[] = [
    {
      id: 'inquiries',
      label: 'Inquiries',
      count: inquiriesCount,
      tour: TOUR.myGigsTabInquiries,
    },
    {
      id: 'applicants',
      label: 'Applicants',
      count: applicantsCount,
      tour: TOUR.myGigsTabApplicants,
    },
    { id: 'offers', label: 'Offers', count: offersCount, tour: TOUR.myGigsTabOffers },
    { id: 'payment_history', label: 'Payment History', tour: TOUR.myGigsTabPayments },
  ];

  return (
    <div className="mb-6">
      <div className="mb-6 flex items-center justify-between gap-4">
        <h1 className="text-3xl font-bold tracking-tight text-white">My Gigs</h1>
        <TakeTourButton tourId="hiring" />
      </div>

      {/* Main navigation tabs */}
      <div
        {...tourTarget(TOUR.myGigsTabs)}
        className="flex items-center gap-6 border-b border-white/10 pb-1 overflow-x-auto no-scrollbar"
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              {...tourTarget(tab.tour)}
              onClick={() => onTabChange(tab.id)}
              className={`group relative flex items-center gap-2.5 pb-3 text-sm font-semibold whitespace-nowrap transition-colors ${
                isActive ? 'text-white' : 'text-zinc-400 hover:text-zinc-200'
              }`}
            >
              <span>{tab.label}</span>
              {typeof tab.count === 'number' && (
                <span
                  className={`inline-flex min-h-5 min-w-5 items-center justify-center rounded-full px-2 text-xs font-bold ${
                    isActive ? 'bg-white text-black' : 'bg-zinc-800 text-zinc-300'
                  }`}
                >
                  {tab.count}
                </span>
              )}
              {isActive && (
                <span className="absolute bottom-0 left-0 right-0 h-[2px] rounded-full bg-white" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
